import { useCallback, useEffect, useState } from '../app-owner/react';

/** Open/close flag for an overlay that is NOT part of the URL: opening pushes a marker history entry, Back closes it. */
export function useSheetFlag(): [boolean, (v: boolean) => void] {
  const [open, setOpen] = useState(false);
  const set = useCallback((v: boolean) => {
    if (v) {
      history.pushState({ plFlag: true }, '', location.href);
      setOpen(true);
    } else if ((history.state as any)?.plFlag) history.back();
    else setOpen(false);
  }, []);
  useEffect(() => {
    const onPop = () => { if (!(history.state as any)?.plFlag) setOpen(false); };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  return [open, set];
}
